const marketingUrls = {
    contact: {
        en: 'https://hello.iconosquare.com/en/contact-home',
        fr: 'https://hello.iconosquare.com/fr/contact-home-1',
        es: 'https://hello.iconosquare.com/es/contact-home'
    },
    terms_of_use: {
        en: 'https://iconosquare.com/terms-of-use',
        fr: 'https://www.iconosquare.com/fr/terms-of-use',
        es: 'https://www.iconosquare.com/es/terms-of-use'
    },
    terms_of_subscription: {
        en: 'https://iconosquare.com/terms-of-subscription',
        fr: 'https://iconosquare.com/fr/terms-of-subscription',
        es: 'https://iconosquare.com/es/terms-of-subscription'
    },
    preference_center: {
        en: 'https://iconosquare.com/email-preference-center',
        fr: 'https://iconosquare.com/fr/email-preference-center',
        es: 'https://iconosquare.com/es/email-preference-center'
    },
    faq: 'https://support.iconosquare.com',
    privacy_policy: {
        en: 'https://iconosquare.com/privacy-policy',
        fr: 'https://iconosquare.com/fr/privacy-policy',
        es: 'https://iconosquare.com/es/privacy-policy'
    },
    gdpr: {
        en: 'https://iconosquare.com/gdpr-and-iconosquare',
        fr: 'https://iconosquare.com/fr/gdpr-and-iconosquare',
        es: 'https://iconosquare.com/es/gdpr-and-iconosquare'
    },
    request_about_private_data: {
        en: 'https://hello.iconosquare.com/en/contact',
        fr: 'https://hello.iconosquare.com/fr/contact',
        es: 'https://hello.iconosquare.com/es/contact'
    },
    partner_program_signup: 'https://partner.iconosquare.com/',
    g2_crowd: 'https://www.g2.com/products/iconosquare/reviews/start',
    capterra: 'https://reviews.capterra.com/products/new/a9fd63a0-15b1-40d0-9c52-a7cb00546c95',
    book_a_demo: {
        en: 'https://hello.iconosquare.com/demo',
        fr: 'https://hello.iconosquare.com/fr/demo',
        es: 'https://hello.iconosquare.com/es/demo'
    },
    pricing: {
        en: 'https://www.iconosquare.com/plans-and-pricing',
        fr: 'https://www.iconosquare.com/fr/tarifs',
        es: 'https://www.iconosquare.com/es/planes-y-precios'
    },
    pricing_features: {
        en: 'https://www.iconosquare.com/plans-and-pricing#pricing-comparison',
        fr: 'https://www.iconosquare.com/fr/tarifs#pricing-comparison',
        es: 'https://www.iconosquare.com/es/planes-y-precios#pricing-comparison'
    }
} as const;

export default marketingUrls;
